<template>
	<EventApplication
		action="periodReview"
		title="기간별 리뷰수"
		yAxisTitle="리뷰수"
		dailyCount
	/>
</template>
<script>
	import EventApplication from '@/components/operation/EventStatistic/EventApplication.vue';

	export default {
		name: 'EventGenderStatistics',
		components: {
			EventApplication,
		},
		data() {
			return {};
		},
	};
</script>
<style lang="scss" scoped></style>
